import { AppModel as AppModelBase } from '@ortho-next/nextray-core';
import { Matrix4, Vector3 } from 'three';
import { Context } from './Context';

/**
 * Model used by angular to create bindings. Only three.js part can set this values.
 */
export class AppModel extends AppModelBase {
	protected declare _context: Context;
	public calibrationEllipsePoints?: Vector3[];
	public ringMatrix?: Matrix4;
	public angle?: number;
	public frontal?: number;
	public axial?: number;
	public planeRotation?: number;
}
